import { c as _c } from "react/compiler-runtime";
import ContractorCard from "../../../../_components/global/ContractorCard";
import ContractorCardSkeleton from "./ContractorCardSkeleton";
import { mapContractorMatch } from "../_utils/mapContractorMatch";
import { inhomzEvents } from "../../../../_lib/events";
const SCROLL_SKELETON_COUNT = 3;
const LIST_SKELETON_COUNT = 4;
function ContractorRow(t0) {
  const $ = _c(4);
  const {
    contractors
  } = t0;
  let t1;
  if ($[0] !== contractors) {
    t1 = contractors.map(_temp);
    $[0] = contractors;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] !== t1) {
    t2 = <ul className="scrollbar-hide flex snap-x snap-mandatory w-full gap-3 overflow-x-auto scroll-px-4 px-4 pb-1">{t1}</ul>;
    $[2] = t1;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  return t2;
}

// `variant="scroll"` (default) is the single horizontally-scrollable row used
// in the normal mobile/tablet page flow. `variant="list"` is a vertical
// column, used only inside the desktop sidebar dock — the caller
// (DesignIdeaPageLayout) picks which one to render. `contractors` is the
// real /v1/api/digital-profiles/top result for the clicked image's primary
// tag, fetched server-side in page.jsx — this component is presentational
// only, no fetching of its own.
//
// `isLoading` is for a different gap entirely: whether a city's been picked
// at all (CityPopupProvider's CITY_SELECTION_STATUS) can only be known after
// mount (localStorage), so DesignIdeaPageLayout passes this true for that
// brief CHECKING window rather than guessing — avoids flashing "no city"
// content at returning visitors who already have one stored.
function _temp(contractor, index) {
  return <li key={contractor.contractorProfileId ?? index} className="w-[380px] flex-shrink-0 snap-start"><ContractorCard {...mapContractorMatch(contractor)} trackingEvent={inhomzEvents.designDetail.CONTRACTOR_CARD_CLICKED} /></li>;
}
export default function DesignIdeaContractorRows(t0) {
  const $ = _c(13);
  const {
    contractors: t1,
    variant: t2,
    isLoading: t3
  } = t0;
  let t4;
  if ($[0] !== t1) {
    t4 = t1 === undefined ? [] : t1;
    $[0] = t1;
    $[1] = t4;
  } else {
    t4 = $[1];
  }
  const contractors = t4;
  const variant = t2 === undefined ? "scroll" : t2;
  const isLoading = t3 === undefined ? false : t3;
  if (isLoading) {
    const count = variant === "list" ? LIST_SKELETON_COUNT : SCROLL_SKELETON_COUNT;
    if (variant === "list") {
      let t5;
      if ($[2] !== count) {
        t5 = <div className="flex flex-col gap-4 px-4 py-4">{Array.from({
            length: count
          }).map(_temp2)}</div>;
        $[2] = count;
        $[3] = t5;
      } else {
        t5 = $[3];
      }
      return t5;
    }
    let t5;
    if ($[4] !== count) {
      t5 = <div className="flex w-full gap-3 overflow-x-auto no-scrollbar px-4 pb-1">{Array.from({
          length: count
        }).map(_temp3)}</div>;
      $[4] = count;
      $[5] = t5;
    } else {
      t5 = $[5];
    }
    return t5;
  }
  if (contractors.length === 0) {
    let t5;
    if ($[6] === Symbol.for("react.memo_cache_sentinel")) {
      t5 = <p className="px-4 py-4 m3-body-medium text-[--textSecondarySecondary]">No matched professionals yet for this design idea.</p>;
      $[6] = t5;
    } else {
      t5 = $[6];
    }
    return t5;
  }
  if (variant === "list") {
    let t5;
    if ($[7] !== contractors) {
      t5 = contractors.map(_temp4);
      $[7] = contractors;
      $[8] = t5;
    } else {
      t5 = $[8];
    }
    let t6;
    if ($[9] !== t5) {
      t6 = <ul className="flex flex-col gap-4 px-4 py-4">{t5}</ul>;
      $[9] = t5;
      $[10] = t6;
    } else {
      t6 = $[10];
    }
    return t6;
  }
  let t5;
  if ($[11] !== contractors) {
    t5 = <div className="flex flex-col gap-3 py-4"><ContractorRow contractors={contractors} /></div>;
    $[11] = contractors;
    $[12] = t5;
  } else {
    t5 = $[12];
  }
  return t5;
}
function _temp4(contractor, index_1) {
  return <li key={contractor.contractorProfileId ?? index_1}><ContractorCard {...mapContractorMatch(contractor)} trackingEvent={inhomzEvents.designDetail.CONTRACTOR_CARD_CLICKED} /></li>;
}
function _temp3(__0, index_0) {
  return <ContractorCardSkeleton key={index_0} className="w-[380px] flex-shrink-0" />;
}
function _temp2(_, index) {
  return <ContractorCardSkeleton key={index} />;
}